import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './features/counterSlice';
import deviceReducer from './features/deviceSlice';

export default configureStore({
  reducer: {
    counter: counterReducer,
    device: deviceReducer,
  },
});